<template>
  <div class="k2c-ch" role="group" :aria-label="tx('ch.title')">
    <div class="k2c-ch-h">
      <h4>{{ tx("ch.title") }}</h4>
      <button type="button" class="k2c-cx" data-fk="cx" :aria-label="tx('ch.cancel')" @click.stop="$emit('close')">
        <k2-icon n="mdi-close" :s="20" />
      </button>
    </div>
    <div class="k2c-ch-g">
      <button
        v-for="m in options"
        :key="m"
        type="button"
        :data-last="m === lastEst ? '1' : null"
        :data-fk="'pick-' + m"
        :aria-label="m + ' ' + tx('unit.min') + (m === lastEst ? ', ' + tx('ch.last') : '')"
        @click.stop="$emit('pick', m)"
      >
        {{ m }} {{ tx("unit.min") }}<small v-if="m === lastEst">{{ tx("ch.last") }}</small>
      </button>
    </div>
    <button type="button" class="k2c-ch-now" data-fk="pick-0" @click.stop="$emit('pick', 0)">
      <k2-icon n="mdi-flash" :s="20" />
      <span>{{ tx("ch.now") }}</span>
    </button>
  </div>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import kds2Text from "@/mixins/kds2Text";
import { PREP_OPTIONS } from "@/utils/kdsTickets";

// Izbor "Za koliko minuta?" na samoj kartici pri prihvatanju; zadnje izabrano vrijeme je istaknuto.
export default {
  name: "Kds2Chooser",
  components: { K2Icon },
  mixins: [kds2Text],
  props: {
    id: { type: Number, required: true },
    lastEst: { type: Number, default: 15 },
  },
  computed: {
    options() {
      return PREP_OPTIONS;
    },
  },
};
</script>
